var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9453 6.7125H5.82031C5.06198 6.7125 4.34425 6.38467 3.84723 5.83213C4.33277 5.29104 5.03814 4.95 5.82031 4.95H21.7109C22.8657 4.94471 22.8648 3.19191 21.7109 3.1875H5.82031C3.38287 3.1875 1.40625 5.16062 1.40625 7.59375V16.4062C1.40625 18.8394 3.38287 20.8125 5.82031 20.8125H19.9453C21.4081 20.8125 22.5938 19.629 22.5938 18.1688V9.35625C22.5938 7.89602 21.4081 6.7125 19.9453 6.7125ZM19.0625 14.6438C17.9078 14.6385 17.9078 12.8865 19.0625 12.8813C20.2172 12.8865 20.2172 14.6385 19.0625 14.6438Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon_wallet.55b07f7a455a224a40387591b61114af.svg";
export { ForwardRef as ReactComponent };